import { create } from 'zustand'
import { FiFileText, FiMonitor } from 'react-icons/fi'
import { CgGym } from "react-icons/cg"
import { AiOutlineException } from "react-icons/ai";
import { BsGraphUp, BsBrush } from 'react-icons/bs'
import { IconType } from 'react-icons'

export type AIParadigm = 'nlp' | 'cv' | 'ts' | 'anomaly' | 'rl' | 'generative'

export interface Agent {
  id: number
  name: string
  status: 'active' | 'inactive'
  paradigm: AIParadigm
  model?: string
  role?: string
  task?: string
  dataSource?: string
  constraints?: string
}

interface AgentStore {
  agents: Agent[]
  addAgent: (agent: Omit<Agent, 'id'>) => void
  updateAgent: (id: number, updates: Partial<Agent>) => void
  deleteAgent: (id: number) => void
  getParadigmIcon: (paradigm: AIParadigm) => IconType
}

export const paradigmIcons: Record<AIParadigm, IconType> = {
  nlp: FiFileText,
  cv: FiMonitor,
  ts: BsGraphUp,
  anomaly: AiOutlineException,
  rl: CgGym,
  generative: BsBrush,
}

export const useAgentStore = create<AgentStore>((set) => ({
  agents: [
    {
      id: 1,
      name: 'DTaaS LLM',
      status: 'active',
      paradigm: 'nlp',
    },
    {
      id: 2,
      name: 'DTaaS CV',
      status: 'active',
      paradigm: 'cv',
    },
    {
      id: 3,
      name: 'DTaaS Time Series',
      status: 'active',
      paradigm: 'ts',
    },
    {
      id: 4,
      name: 'DTaaS Anomaly Detect',
      status: 'active',
      paradigm: 'anomaly',
    },
    {
      id: 5,
      name: 'DTaaS RL',
      status: 'active',
      paradigm: 'rl',
    },
    {
      id: 6,
      name: 'DTaaS Gen',
      status: 'active',
      paradigm: 'generative',
    }
  ],
  addAgent: (agent) => 
    set((state) => ({
      agents: [...state.agents, { ...agent, id: Math.max(...state.agents.map(a => a.id)) + 1 }]
    })),
  updateAgent: (id, updates) =>
    set((state) => ({
      agents: state.agents.map(agent => 
        agent.id === id ? { ...agent, ...updates } : agent
      )
    })),
  deleteAgent: (id) =>
    set((state) => ({
      agents: state.agents.filter(agent => agent.id !== id)
    })),
  getParadigmIcon: (paradigm) => paradigmIcons[paradigm],
}))
